import { useState } from 'react';
import { IconCheck, IconDatabaseImport, IconEdit, IconPlus, IconRefresh, IconTrash } from '@tabler/icons-react';
import { useToast } from '@hana/ui';
import { useT } from '@hana/i18n';
import './payroll.i18n';
import { STD_DEPTS, STD_EFF, STD_ROWS, nf } from './payrollData';
import s from './payroll.module.css';

// Mint-Payroll tab "Bảng lương chuẩn": lọc phòng · 4 nút thao tác · bảng chức danh × bậc. Chỉ xem; nút ghi báo toast.
export function StdTab({ dense }: { dense: boolean }) {
  const t = useT();
  const toast = useToast();
  const [dept, setDept] = useState<(typeof STD_DEPTS)[number]>('Tất cả');
  const [hist, setHist] = useState<number | null>(null);
  const noWrite = () => toast({ msg: t('pr.noWrite') });
  const rows = STD_ROWS.map((r, i) => ({ r, i })).filter(({ r }) => dept === 'Tất cả' || r[0].startsWith(dept));
  const v = (x: number) => (x ? nf(x) : '—');
  return (
    <>
      <div className={s.stdBar}>
        <div className={s.seg} role="group" aria-label="Lọc phòng">
          {STD_DEPTS.map((d) => <button key={d} type="button" aria-pressed={dept === d} onClick={() => setDept(d)}>{d}</button>)}
        </div>
        <span className={s.stdN}>{t('pr.rows', { n: rows.length })}</span>
        <span className={s.grow} />
        <button type="button" className={s.act} onClick={noWrite}><IconDatabaseImport size={16} aria-hidden="true" />{t('pr.stdLoad')}</button>
        <button type="button" className={s.act} onClick={noWrite}><IconRefresh size={16} aria-hidden="true" />{t('pr.stdSi')}</button>
        <button type="button" className={s.act} onClick={noWrite}><IconCheck size={16} aria-hidden="true" />{t('pr.stdAlw')}</button>
        <button type="button" className={`${s.act} ${s.actPri}`} onClick={noWrite}><IconPlus size={16} aria-hidden="true" />{t('pr.addRow')}</button>
      </div>
      <section className={s.card} aria-label="Bảng lương chuẩn chức danh × bậc" style={{ padding: 0, overflow: 'clip' }}>
        <table className={`${s.tbl} ${s.fixed}`} data-dense={dense ? 1 : undefined}>
          <thead>
            <tr>
              {([['Chức danh × bậc', '22%'], ['Lương vị trí', '10%', 1], ['Căn cứ BHXH', '10%', 1], ['Phụ cấp chuẩn', '10%', 1], ['Gross mục tiêu', '10%', 1], ['Hiệu lực', '11%'], ['Đang áp', '7%', 1], ['', '20%', 1]] as const).map(([h, w, r], i) => (
                <th key={i} scope="col" style={{ width: w }} className={r ? s.r : undefined}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.flatMap(({ r, i }) => {
              const out = [
                <tr key={i}>
                  <td><b className={s.inl}>{r[0]}</b> <span className={s.inlLb}>× {r[1]}</span><span>{r[2]}</span></td>
                  {[r[3], r[4], r[5], r[6]].map((x, j) => <td key={j} className={s.r}>{v(x)}</td>)}
                  <td>{STD_EFF}</td>
                  <td className={s.r}>{r[7]}</td>
                  <td className={s.r}>
                    <div className={s.rowAct}>
                      <button type="button" onClick={noWrite}><IconEdit size={16} aria-hidden="true" />{t('pr.edit')}</button>
                      <button type="button" aria-pressed={hist === i} onClick={() => setHist(hist === i ? null : i)}>{t('pr.history')}</button>
                      <button type="button" className={s.del} aria-label={`Xoá dòng ${r[0]} ${r[1]}`} onClick={noWrite}><IconTrash size={16} aria-hidden="true" />{t('pr.delete')}</button>
                    </div>
                  </td>
                </tr>,
              ];
              if (hist === i) {
                out.push(
                  <tr key={`${i}h`} className={s.histRow}>
                    <td colSpan={8}>
                      {[[STD_EFF, `Lương vị trí ${nf(r[3])} · căn cứ BHXH ${nf(r[4])}`, 'HANHLTM'], ['01/Jul/2025', `Lương vị trí ${nf(r[3] * 0.94)} · căn cứ BHXH ${nf(r[4] * 0.94)}`, 'HANHLTM'], ['01/Jan/2025', 'Bản đầu · nạp nháp từ khung bậc', 'Hệ thống']].map(([e, k, w]) => (
                        <div key={e} className={s.hv}><b>{e}</b><span>{k}</span><span className={s.hvWho}>{w}</span></div>
                      ))}
                    </td>
                  </tr>,
                );
              }
              return out;
            })}
          </tbody>
        </table>
      </section>
    </>
  );
}
